module.exports = __webpack_public_path__ + "static/media/keras.aba3531c.png";